import { render } from "./radarChart.vue?vue&type=template&id=e074e0fe"
import script from "./radarChart.vue?vue&type=script&lang=js"
export * from "./radarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__